/**
 * A public ICE candidate (a server-reflexive candidate from STUN, or a relay
 * candidate from TURN) is REQUIRED for on-net ext↔ext calls: FreeSWITCH bridges
 * two WebRTC legs and needs a routable candidate on each. With host-only
 * (private) candidates the bridge fails with INCOMPATIBLE_DESTINATION. TURN
 * additionally covers symmetric-NAT / mobile networks where a reflexive
 * candidate isn't reachable.
 *
 * In production the platform's own coturn (STUN+TURN, with short-lived
 * credentials) is delivered in the mint response and passed to
 * `Phone.authenticate`. This public STUN server is only a development fallback
 * for when no ICE config has been supplied yet.
 */
export const DEFAULT_ICE_SERVERS: RTCIceServer[] = [{ urls: 'stun:stun.cloudflare.com:3478' }];

/**
 * Resolve the ICE servers to use, in precedence order:
 *   1. per-session config from the mint response (best — includes TURN),
 *   2. the constructor `iceServers` option,
 *   3. the public-STUN development fallback.
 */
export function resolveIceServers(
  fromAuth: RTCIceServer[] | undefined,
  fromOptions: RTCIceServer[] | undefined,
): RTCIceServer[] {
  if (fromAuth && fromAuth.length) return fromAuth;
  if (fromOptions && fromOptions.length) return fromOptions;
  return DEFAULT_ICE_SERVERS;
}
